import { render, staticRenderFns } from "./AdminEditGenericObject.vue?vue&type=template&id=491bbcc8&scoped=true&"
import script from "./AdminEditGenericObject.vue?vue&type=script&lang=js&"
export * from "./AdminEditGenericObject.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditGenericObject.vue?vue&type=style&index=0&id=491bbcc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491bbcc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491bbcc8')) {
      api.createRecord('491bbcc8', component.options)
    } else {
      api.reload('491bbcc8', component.options)
    }
    module.hot.accept("./AdminEditGenericObject.vue?vue&type=template&id=491bbcc8&scoped=true&", function () {
      api.rerender('491bbcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/device_types/AdminEditGenericObject.vue"
export default component.exports